import type { IResourceRepository, ResourceListQuery } from '@domain/data-contracts/resource-repository.interface';
import type { Resource } from '@domain/models/resource.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class ResourcesService {
  public constructor(private readonly repo: IResourceRepository) {}

  public list(query: ResourceListQuery): Promise<PagedResult<Resource>> {
    return this.repo.list(query);
  }
}
